import axios from "../../index";
import api from "./blocks.api";

export default {
  /**
   * 获取积木列表 @data { createBy: '创建人id' }
   */
  getBlockList(data = {}) {
    return axios.post(api.getBlockList, data);
  },
  /**
   * 获取积木列表 -- 我的模型和公共模型部分  @data { createBy: '创建人id' }
   */
  getModelBlockList(data = {}) {
    return axios.post(api.getModelBlockList, data);
  },
  /**
   * 获取积木列表 -- 实训模型部分  @data { createBy: '创建人id', quoteTrainId: '引用实训id' }
   */
  getTrainModelBlockList(data = {}) {
    return axios.post(api.getTrainModelBlockList, data);
  },
  /**
   * 保存项目代码 @data buildingBlocks 项目积木;buildingBlocksType积木类型 isComplete是否完成 isPublic是否公开 pid  trainingId实训id userRole用户角色
   */
  saveProjectCode(data = {}) {
    return axios.post(api.saveProjectCode, data);
  },
  /**
   * 提交题解 @data buildingBlocks 项目积木;buildingBlocksType积木类型 isComplete是否完成 isPublic是否公开 pid  trainingId实训id userRole用户角色
   */
  submitProjectCode(data = {}) {
    return axios.post(api.submitProjectCode, data);
  },
  /**
   获取项目信息 @data createBy创建人id trainingId实训id
   */
  getProjectInfo(data = {}) {
    return axios.post(api.getProjectInfo, data);
  },
  /**
   根据实训id查询实训信息 @data  trainingId实训id
   */
  getTrainingByTrainingId(data = {}) {
    return axios.post(api.getTrainingByTrainingId, data);
  },
  /**
   新增自定义积木 @data  blocksLevel defBlocksContent defBlocksName  parentId
   */
  insertDefBlocks(data = {}) {
    return axios.post(api.insertDefBlocks, data);
  },
  /**
   获取新增自定义积木 @data  
   */
  getDefBlocksByUserId(data = {}) {
    return axios.post(api.getDefBlocksByUserId, data);
  },
  /**
   删除自定义积木 @data  defBlocksId 自定义积木块id 
   */
   deleteDefBlocks(data = {}) {
    return axios.post(api.deleteDefBlocks, data);
  },
  /**
   查询媒体积木 @data  trainingId 实训id  userId 媒体积木的创建人id
   */
  getMediaByTrainingId(data = {}) {
    return axios.post(api.getMediaByTrainingId, data);
  },
  /**
   删除媒体积木 @data  mediaFileName 媒体名称  mediaId 媒体id
   */
  deleteMedia(data = {}) {
    return axios.post(api.deleteMedia, data);
  },
  /**
   修改媒体积木 @data  mediaFileName 媒体名称  mediaId 媒体id
   */
  updateMedia(data = {}) {
    return axios.post(api.updateMedia, data);
  },
  /**
   新增媒体积木 @data  mediaFileName 媒体名称  mediaFileUrl 媒体文件url trainingId 实训id  userId 项目创建人id
   */
  insertMedia(data = {}) {
    return axios.post(api.insertMedia, data);
  },

};
